module.exports = __webpack_public_path__ + "img/email.9bd810a.png";